import {
  GET_BOOSTER_PLAN_MIN_AMOUNT,
  GET_BOOSTER_PLAN_MIN_AMOUNT_SUCCESS,
  GET_BOOSTER_PLAN_MIN_AMOUNT_FAILED,
  GET_ADVANCE_PLAN_MIN_AMOUNT,
  GET_ADVANCE_PLAN_MIN_AMOUNT_SUCCESS,
  GET_ADVANCE_PLAN_MIN_AMOUNT_FAILED,
  GET_MIXED_FUNDS,
  GET_MIXED_FUNDS_SUCCESS,
  GET_MIXED_FUNDS_FAILED,
  GET_EQUITY_FUNDS,
  GET_EQUITY_FUNDS_SUCCESS,
  GET_EQUITY_FUNDS_FAILED,
  GET_IMMF_FUND,
  GET_IMMF_FUND_SUCCESS,
  GET_IMMF_FUND_FAILED,
} from "./constant";

export function getEquityFunds() {
  return {
    type: GET_EQUITY_FUNDS
  };
}
export function getEquityFundsSuccess(payload) {
  return {
    type: GET_EQUITY_FUNDS_SUCCESS,
    payload
  };
}

export function getEquityFundsFailed() {
  return {
    type: GET_EQUITY_FUNDS_FAILED,
  };
}

export function getMixedFunds() {
  return {
    type: GET_MIXED_FUNDS
  };
}
export function getMixedFundsSuccess(payload) {
  return {
    type: GET_MIXED_FUNDS_SUCCESS,
    payload
  };
}

export function getMixedFundsFailed() {
  return {
    type: GET_MIXED_FUNDS_FAILED,
  };
}

export function getImmfFund() {
  return {
    type: GET_IMMF_FUND
  };
}
export function getImmfFundSuccess(payload) {
  return {
    type: GET_IMMF_FUND_SUCCESS,
    payload
  };
}

export function getImmfFundFailed() {
  return {
    type: GET_IMMF_FUND_FAILED,
  };
}


export function getBoosterPlanMinAmount() {
  return {
    type: GET_BOOSTER_PLAN_MIN_AMOUNT
  };
}
export function getBoosterPlanMinAmountSuccess(payload) {
  return {
    type: GET_BOOSTER_PLAN_MIN_AMOUNT_SUCCESS,
    payload
  };
}

export function getBoosterPlanMinAmountFailed() {
  return {
    type: GET_BOOSTER_PLAN_MIN_AMOUNT_FAILED,
  };
}

export function getAdvancePlanMinAmount() {
  return {
    type: GET_ADVANCE_PLAN_MIN_AMOUNT
  };
}
export function getAdvancePlanMinAmountSuccess(payload) {
  return {
    type: GET_ADVANCE_PLAN_MIN_AMOUNT_SUCCESS,
    payload
  };
}

export function getAdvancePlanMinAmountFailed() {
  return {
    type: GET_ADVANCE_PLAN_MIN_AMOUNT_FAILED,
  };
}